import React from 'react';
import Backdrop from '../Backdrop/Backdrop';
import IModalProps, { TClassOverride } from './IModal';
import close from './images/close.svg?url';

import * as style from './ModalStyle.module.scss'


const Modal: React.SFC<IModalProps> = (props) => {
  const { show, header, cancel, children, buttons, className } = props;
  const styleOverride:TClassOverride = className || {
    container: '',
    dialog: '',
    footer: '',
    close: '',
    content: '',
    header: '',
  };
  return (
    <div>
      <Backdrop show={show} />
      <div className={show ? 'modal fade in block' : ''} role="dialog">
        <div className={`modal-dialog ${styleOverride.dialog}`}>
          <div className={`modal-content ${styleOverride.content}`}>
            <div className={`modal-header ${styleOverride.header}`}>
              <button type="button" className={`${style.closeBtn} close ${styleOverride.close}`} onClick={cancel}>
                {styleOverride.close ? <img alt="close" src={close}/> : <span>&times;</span>}
              </button>
              <h4 className="modal-title">{header}</h4>
            </div>
            <div className={`${style.content} ${styleOverride.container}`} data-cy="modal-content">
              {children}
            </div>
            <div className={`modal-footer ${styleOverride.footer}`} data-cy="modal-buttons">
              {buttons}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
